import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

const SIZES = ['small', 'default'];
const BACKGROUNDS = ['primary', 'secondary', 'white'];
const ICON_ALIGNS = ['left', 'center', 'right'];

class Button extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    block: PropTypes.bool,
    className: PropTypes.string,
    background: PropTypes.oneOf(BACKGROUNDS),
    size: PropTypes.oneOf(SIZES),
    iconName: PropTypes.string,
    iconAlign: PropTypes.oneOf(ICON_ALIGNS),
    onClick: PropTypes.func,
    loading: PropTypes.bool,
    sqaure: PropTypes.bool,
    href: PropTypes.string,
  };

  static defaultProps = {
    block: false,
    className: '',
    background: 'primary',
    iconAlign: 'left',
    size: 'default',
    loading: false,
    sqaure: false,
    onClick: () => {},
  };

  onClick(e) {
    if (!this.props.disabled && !this.props.loading) {
      this.props.onClick(e);
    }
  }

  render() {
    const {
      id,
      name,
      block,
      className,
      background,
      size,
      iconName,
      iconAlign,
      loading,
      square,
      href,
      children,
    } = this.props;

    const align = children ? iconAlign : 'center';
    const icon = iconName && (
      <span
        key="button-icon"
        className={classnames(
          'common-button__font-icon',
          `common-button__font-icon--${align}`
        )}
      >
        <i className={iconName} />
      </span>
    );

    const label =
      children && iconName ? (
        <span key="button-label" className="common-button__label">
          {iconAlign === 'right' ? [children, icon] : [icon, children]}
        </span>
      ) : (
        children
      );

    return (
      <a
        id={id}
        name={name ? name : id}
        className={classnames(
          'common-button',
          className,
          `common-button--bg-${background}`,
          `common-button--size-${size}`,
          {
            'common-button--block': block,
            'common-button--loading': loading,
            'common-button--square': square,
          }
        )}
        onClick={e => this.onClick(e)}
        href={href}
      >
        {loading ? <i className="fa fa-spin fa-circle-o-notch" /> : label}
      </a>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/button/Button.js